<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro" :mensagens="msgErros" />
    <table>
      <thead>
        <tr>
          <th>CPF</th>
          <th>Nome</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="servidor in servidoresFormat" :key="servidor.id">
          <td data-label="CPF:" class="topo-card">
            <span>{{ formatarCPF(servidor.cpf) }}</span>
          </td>
          <td data-label="Nome:">
            <span>{{ servidor.nome }}</span>
          </td>
          <td class='coluna-acoes'>
            <div class="coluna-acoes-tabela">
              <!-- Visualizar -->
              <div class="icone-tabela">
                <router-link :to="{
                  name: 'ServidorShow',
                  params: { id: servidor.id },
                }">
                  <img src="../../assets/imagens/icon-view.svg" alt="Visualizar" title="Visualizar" />
                </router-link>
              </div>
              <!-- Editar -->
              <div v-if="podeEscrever('servidores')" class="icone-tabela">
                <router-link :to="{
                  name: 'ServidorEdit',
                  params: { id: servidor.id },
                }">
                  <img src="../../assets/imagens/icon-edit.svg" alt="Editar" title="Editar" />
                </router-link>
              </div>
              <!-- Excluir -->
              <span v-if="podeEscrever('servidores')" class="icone-tabela" type="button" @click="opcoesExcluir(servidor.id)">
                <img src="../../assets/imagens/icon-delete-preto.svg" alt="Excluir" title="Excluir" />
              </span>
            </div>
          </td>
          <!-- Modal de Exclusão -->
          <div class="modal-exclusao" :id="servidor.id">
            <div class="modal-mask">
              <div class="modal-container">
                <div class="modal-header">
                  <h2>Deseja mesmo excluir esse(a) Servidor(a)?</h2>
                </div>
                <div class="modal-body">
                  <p>Dados do(a) Servidor(a):</p>
                  <div class="dados">
                    <div class="texto-centralizado">
                      CPF: <span>{{ formatarCPF(servidor.cpf) }}</span>
                    </div>
                    <div class="texto-centralizado">
                      Nome: <span>{{ servidor.nome }}</span>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn-confirmar-exclusao" @click="excluirLinha(servidor.id)">Sim</button>
                  <button class="btn-cancelar-exclusao" @click="opcoesExcluir(servidor.id)">Não</button>
                </div>
              </div>
            </div>
          </div>
        </tr>
        <tr v-if="!servidoresFormat || servidoresFormat.length === 0" class="sem-resultados">
          <td colspan="4">
            <p><b>Nenhum Resultado Encontrado</b></p>
          </td>
        </tr>
      </tbody>
    </table>

    
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import MsgErroFormularios from "../MsgErroFormularios";
import ServidorApi from "../../services/ServidorApi";
import LotacaoServidorApi from "../../services/LotacaoServidorApi";

export default {
  name: "TabelaResultadosServidores",
  props: {
    servidores: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    MsgErroFormularios,
  },
  data() {
    return {
      msgErros: { servidor: '' },
      erro: false,
      servidorParaExcluir: null, // Armazena o servidor a ser excluído
      lotacaoServidorApi: null,
    };
  },
  computed: {
    servidoresFormat() {
      return this.servidores.map((s) => ({
        ...s,
        // Adicione formatações se necessário
      }));
    },
  },
  created() {
    this.servidorApi = new ServidorApi();
    this.lotacaoServidorApi = new LotacaoServidorApi();
  },
  methods: {
    abrirModalExclusao(servidor) {
      this.servidorParaExcluir = servidor;
      this.erro = false;
      this.msgErros.servidor = '';
    },
    fecharModalExclusao() {
      this.servidorParaExcluir = null;
    },
    async excluirLinha(servidorId) {
        this.opcoesExcluir(servidorId)

        try {
          this.carregando = true;
          this.erro = false;

          if (this.servidorApi.cancelTokens.destroyServidor) {
            this.servidorApi.cancelTokens.destroyServidor.cancel();
          }

          // O backend apaga as lotações junto com o servidor, na mesma transação.
          // Apagar lotação por lotação antes deixava o cadastro pela metade
          // quando uma delas não podia ser excluída.
          await this.servidorApi.destroyServidor(servidorId);
          window.location.reload();
          
        } catch (err) {
          if (this.servidorApi.isCancel(err)) {
            return;
          }

          this.carregando = false;
          this.erro = true;

          this.msgErros.servidor = err.response?.data?.error
            || "Não foi possível excluir o(a) servidor(a), pois ele(a) está vinculado(a) a um Formulário."
        }
      },
      opcoesExcluir(servidorId) {
        let modalExclusao = document.getElementsByClassName('modal-exclusao')

        for (let i = 0; i < modalExclusao.length; i++) {
          if (modalExclusao[i].id == servidorId) {
            if (modalExclusao[i].style.visibility !== "visible") {
              modalExclusao[i].style.visibility = "visible"
            } else {
              modalExclusao[i].style.visibility = "hidden"
            }
          }
        }
      },
    formatarData(value) {
      if (!value) return "";
      return format(parseISO(value), "dd/MM/yyyy");
    },
    formatarCPF(cpf) {
      if (!cpf) return "";
      const cpfLimpo = cpf.replace(/\D/g, '');
      if (cpfLimpo.length !== 11) return cpf; // Retorna o original se não for um CPF válido
      return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    },
  },
};
</script>

<style lang="scss">
  @import "../../assets/stylesheets/tabelaResultados.scss";
</style>